import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConvenioRepository } from 'src/app/domain/service/convenio/convenio-repository';
import { Convenio, FiltroConvenio } from 'src/app/domain/model/convenio/convenio';

/**
 * Adaptador HTTP: HttpConvenioRepository
 *
 * Implementa el puerto ConvenioRepository para comunicación HTTP con backend.
 * Realiza llamadas REST al backend Spring Boot (ConvenioController).
 *
 * Arquitectura Hexagonal:
 * - Este adaptador está en infraestructura
 * - Implementa el puerto ConvenioRepository del dominio
 *
 * Backend: 580-girop_servicios-ms (puerto 8080)
 *
 * @author GitHub Copilot - Migración GIROP
 */
@Injectable({ providedIn: 'root' })
export class HttpConvenioRepository implements ConvenioRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/convenios`;

  async buscarConvenios(filtro: FiltroConvenio): Promise<Convenio[]> {
    let params = new HttpParams();
    
    if (filtro.nmconsecutivoCliente !== undefined && filtro.nmconsecutivoCliente !== null) {
      params = params.set('nmconsecutivoCliente', filtro.nmconsecutivoCliente.toString());
    }
    if (filtro.cdconvenio) {
      params = params.set('cdconvenio', filtro.cdconvenio);
    }
    if (filtro.dsconvenio) {
      params = params.set('dsconvenio', filtro.dsconvenio);
    }
    if (filtro.snactivo !== undefined && filtro.snactivo !== null) {
      params = params.set('snactivo', filtro.snactivo);
    }
    
    return firstValueFrom(
      this.http.get<Convenio[]>(this.baseUrl, { params })
    );
  }

  async obtenerPorId(nmconsecutivo: number): Promise<Convenio> {
    return firstValueFrom(
      this.http.get<Convenio>(`${this.baseUrl}/${nmconsecutivo}`)
    );
  }

  async listarActivos(): Promise<Convenio[]> {
    return firstValueFrom(
      this.http.get<Convenio[]>(`${this.baseUrl}/activos`)
    );
  }

  async listarPorCliente(nmconsecutivoCliente: number): Promise<Convenio[]> {
    return firstValueFrom(
      this.http.get<Convenio[]>(`${this.baseUrl}/cliente/${nmconsecutivoCliente}`)
    );
  }
}
